async function Loader(id, selector) {
    const api_route = 'http://localhost:8080';
    //const api_route = 'https://ivafactorytest.teleperformance.co:443';
    const widget_route = 'http://localhost:3001';
    //const widget_route = 'https://ivafactorytest.teleperformance.co:3008';

    let configWidget = await getConfig(id).then(res => {
        return res;
    });

    const config = {
        widget: {
            position: configWidget.config.widget_position_type, // relative, absolute, fixed
            positionLocation: configWidget.config.widget_position_screen, // leftTop, rightTop, leftBotton, rightBotton
            maxWidth: '500px',
        },
        buttonOpenPosition: configWidget.config.open_button_position, // leftTop, rightTop, leftBotton, rightBotton
    }
    const content = document.querySelector(selector);
    content.style.display = 'none';

    content.style.width = '100%';
    content.style.maxWidth = config.widget.maxWidth;
    content.style.height = '600px';

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';

    const buttonOpen = document.createElement('button');
    buttonOpen.style.display = 'block';

    const buttonClose = document.createElement('button');

    // -----Events-----
    buttonOpen.addEventListener('click', function (e) {
        hideOpenButton();
    });

    buttonClose.addEventListener('click', function () {
        showOpenButton();
    });

    // -----Methods-----
    const _init_ = () => {

        content.style.position = config.widget.position;
        iframe.style.position = config.widget.position;
        iframe.style.maxWidth = config.widget.maxWidth;

        buttonOpen.id = 'button-open';
        
        switch (config.widget.positionLocation) {
            case 'leftTop':
                content.style.left = '15px';
                content.style.top = '15px';

                iframe.style.left = '15px';
                iframe.style.top = '15px';
                break;
            
            case 'leftBottom':
                content.style.left = '15px';
                content.style.bottom = '15px';

                iframe.style.left = '15px';
                iframe.style.bottom = '15px';
                break;
            case 'rightTop':
                content.style.right = '15px';
                content.style.top = '15px';

                iframe.style.right = '15px';
                iframe.style.top = '15px';
                break;
            case 'rightBottom':
                content.style.right = '15px';
                content.style.bottom = '15px';

                iframe.style.right = '15px';
                iframe.style.bottom = '15px';
                break;
        }

        console.log('content.style', content.style)

        buttonOpen.type = 'button';
        buttonOpen.style.position = 'fixed';
        buttonOpen.style.cursor = 'pointer';
        buttonOpen.style.backgroundColor = 'transparent';
        buttonOpen.style.border = 'none';

        switch (config.buttonOpenPosition) {
            case 'leftTop':
                buttonOpen.style.left = '15px';
                buttonOpen.style.top = '15px';
                break;
            case 'rightTop':
                buttonOpen.style.right = '15px';
                buttonOpen.style.top = '15px';
                break;
            case 'leftBottom':
                buttonOpen.style.left = '15px';
                buttonOpen.style.bottom = '15px';
                break;
            case 'rightBottom':
                buttonOpen.style.right = '15px';
                buttonOpen.style.bottom = '15px';
                break;
        }

        const icon = document.createElement('img');
        icon.src = 'https://images2.imgbox.com/a0/e7/xg5wiR3D_o.png';
        icon.alt = 'Chat';
        icon.style.height = '65px';
        icon.style.width = '65px';

        buttonOpen.appendChild(icon);

        content.parentNode.appendChild(buttonOpen);
    }

    const showOpenButton = () => {
        buttonOpen.style.display = 'block';
        iframe.style.display = 'none';
        content.style.display = 'none';
    }

    const hideOpenButton = () => {
        buttonOpen.style.display = 'none';
        iframe.style.display = 'block';
        content.style.display = 'block';
    }

    const getWidget = () => {

        content.style.position = 'fixed';

        buttonClose.id = 'button-close';
        buttonClose.type = 'button';
        buttonClose.style.position = 'absolute';
        buttonClose.style.cursor = 'pointer';
        buttonClose.style.backgroundColor = 'transparent';
        buttonClose.style.border = 'none';
        buttonClose.style.right = '20px';
        buttonClose.style.top = '-16px';
        buttonClose.style.zIndex = '2';

        const iconClose = document.createElement('img');
        iconClose.src = 'https://images2.imgbox.com/a0/45/xemWAvQf_o.png';
        iconClose.style.width = '24px';

        buttonClose.appendChild(iconClose);
        //console.log('configWidget', configWidget)
        iframe.src = widget_route + '/chatbot?project='+configWidget.project.name+'&project_id='+configWidget.project.id
            +'&template='+configWidget.config.template+'&user=U2FsdGVkX18YPvJiLer0ZligVQ1bZVQa6Ia92hOM+fFVNJTCQAch9c9OvNq33Q16f7VezEUco/HffXsSLhHtJ7des7rKnmo08mz/U0jaUY4eGH6YYz0dpQSEyqXtx40zOWJ82N8e2EoTcNkBLvmjXEfoYIFo3VsUrJHT9Pb9qAc='; // Define Widget Host
        iframe.style.border = 'none';
        iframe.height = '600';
        iframe.style.width = '100%';
        iframe.style.maxWidth = config.widget.maxWidth;

        content.appendChild(buttonClose);
        content.appendChild(iframe);
    }

    async function getConfig(project_id) {
        const url = api_route + `/api/v2/project/${project_id}/widget/config/loader`;
        const res = await fetch(url);
        return await res.json();
    }

    _init_();
    getWidget();
}

module.exports = {Loader}